import React from "react"
import { navigate } from "gatsby"
import { pageStore, locationStore } from "state/store-zustand"

import Logo from 'components/header/logo'
import ArrowLeft from "images/svg/icons/arrow-left.svg"
import { MdShare } from '@react-icons/all-files/md/MdShare'
import DateToCalendar from 'components/shared/dateToCalendar'

import Headroom from "react-headroom"
import SavedList from 'components/header/SavedList'
import { RWebShare } from "react-web-share"

import MobileMenu from './menus/mobileMenu'
import TopMenu from "components/header/menus/topMenu"

import "./header.scss"
import "./menus/mobileMenu.scss"

const PostHeader = ({ ...props }) => {
  const {
    breadcrumbs,
    city,
    citySelected,
    eventDetails,
    showCalendar = false,
    showSave = true,
    showSearch,
    post,
    url
  } = props

  const embedded = pageStore((state) => state.embedded)
  const isPhone = pageStore((state) => state.isPhone)

  const handleAction = (action) => {
    // Do something
  }

  const {
    properties,
    title
  } = eventDetails || {}

  const {
    description,
    location,
    start_date,
    end_date
  } = properties || {} // Safely destructure

  if (embedded) return null

  return (
    <Headroom>
      <header className="main" id="main-header">
        {!isPhone &&
          <TopMenu />
        }
        <div className="main-header-body">
          <div className="container">

            <div className="columns is-gapless-tablet is-mobile is-flex">
              <div className={`column left is-2-desktop is-1-tablet is-1-mobile`}>
                <Logo full={true} />
              </div>
              <div className={`column is-flex nav is-8 is-6-mobile`}>
                <div className={' breadcrumbs'}>
                  <a className='back-button' onClick={() => navigate(-1)}>
                    <button className='button button-prev transparent'><ArrowLeft /></button>
                  </a>
                  {breadcrumbs ? breadcrumbs : null}
                </div>
              </div>
              <div className={`column actions left is-2`}>
                {showSave &&
                  <SavedList post={post} />
                }

                {showCalendar && eventDetails &&
                  <DateToCalendar
                    address={location?.address}
                    description={description}
                    start_date={start_date}
                    end_date={end_date}
                    name={title}
                    iconOnly={true}
                  />
                }

                <RWebShare
                  data={{
                    text: "Check this out on Vibemap",
                    url: url ? url : post?.seo?.opengraphUrl,
                    title: "Share this article from Vibemap"
                  }}
                  sites={['copy', 'mail', 'twitter', 'facebook', 'whatsapp', 'reddit']}
                  onClick={(e) => handleShare(e)}>
                  <button className='button ui secondary basic'>
                    <MdShare size='1.6em' />
                  </button>
                </RWebShare>
              </div>
              <div className={`column left is-1-desktop is-1-tablet is-2-mobile`}>
                <MobileMenu />
              </div>
            </div>
          </div>
        </div>
      </header>
    </Headroom>
  )
}

export default PostHeader
